<template>
    <!-- SECTION: Template -->
    <div class="sub-page">
        <!-- ANCHOR: PageTitle -->
        <!-- <PageTitle
            main-title="한국고등직업교육학회"
            sub-title="창립 25주년 기념 공동학술포럼"
            bg-color=""
        /> -->

        <p
            class="text-center"
            style="color: #090d54;"
            :class="{
                'pt-15 le-heading5': $vuetify.breakpoint.smAndUp,
                'pt-10 le-heading5': $vuetify.breakpoint.xsOnly                    
            }"
        >
            Thanks for Visiting LecoS @ LTE2025!
        </p>

        <!-- ANCHOR: 문의하기 -->
        <section class="c-section d-flex justify-center pt-0">
            <div class="c-contanier">
                <div
                    class="d-flex align-center justify-center"
                    :class="{
                        'py-16': $vuetify.breakpoint.smAndUp,
                    }"
                    :style="$vuetify.breakpoint.xsOnly ? { paddingTop: '6vh', paddingBottom: '6vh' } : {}"
                >
                    <div>
                        <a
                            href="https://wallet.openbadge.net/search/achievement/f05be51c-8d03-8594-8486-01977bc91708"
                            target="_blank"
                            class="d-flex"
                        >
                            <v-img
                                :src="require('@/assets/img/lecoslte2025-sample-badge.png')"
                                :width="$vuetify.breakpoint.mdAndUp ? 230 : ($vuetify.breakpoint.smOnly ? 220 : 160)"
                                alt=""
                            />
                        </a>
                    </div>
                </div>

                <p class="le-text-subtitle2 text-center">
                    <!-- 함께해 온 25년 함께 나아갈 미래!<br /> -->
                    Please enter the information below to issue your badge.
                </p>

                <!-- ANCHOR: Form-문의하기 -->
                <div class="mt-10">
                    <v-form ref="form">
                        <!-- 이름 -->
                        <v-row
                            no-gutters
                            class="d-flex flex-column justify-center align-center"
                        >
                            <v-col
                                cols="10"
                                md="4"
                                sm="8"
                                class="text-right mb-3"
                            >
                                <p class="text-red1">
                                    Fields marked with an asterisk (*) are required.
                                </p>
                            </v-col>

                            <v-col
                                cols="10"
                                md="4"
                                sm="8"
                                class="pb-0 pt-0 mb-2"
                            >
                                <p class="contact_title mb-3">
                                    <strong class="le-text-subtitle3">Name</strong>
                                    <span class="le-text-body2 text-red1 ml-1">*</span>
                                </p>

                                <v-text-field
                                    v-model="name"
                                    :rules="[v => !!v || 'Please enter your name.']"
                                    outlined
                                    color="blue1"
                                    :dense="$vuetify.breakpoint.smAndDown"
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <!-- 이메일 -->
                        <v-row
                            no-gutters
                            class="d-flex flex-column justify-center align-center"
                        >
                            <v-col
                                cols="10"
                                md="4"
                                sm="8"
                                class="pb-0 pt-0 mb-2"
                            >
                                <p class="contact_title mb-3">
                                    <strong class="le-text-subtitle3">Email</strong>
                                    <span class="le-text-body2 text-red1 ml-1">*</span>
                                </p>

                                <v-text-field
                                    v-model="email"
                                    :rules="[
                                        v => !!v || 'Please enter your email.',
                                        v => /.+@.+\..+/.test(v) || 'Please enter a valid email address.'
                                    ]"
                                    outlined
                                    color="blue1"
                                    placeholder="info@lecos.co.kr"
                                    :dense="$vuetify.breakpoint.smAndDown"
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row
                            :class="{
                                'mt-10': $vuetify.breakpoint.smAndUp,
                                'mt-3': $vuetify.breakpoint.xsOnly                    
                            }"
                        >
                            <v-col class="d-flex align-center justify-center pt-0 pb-0">
                                <v-btn
                                    color="orange1"
                                    :large="$vuetify.breakpoint.smAndUp"
                                    depressed
                                    class="text-white1"
                                    @click="showIssuingCheckDialogVisible"
                                >
                                    Issue Badge
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-form>
                </div>
            </div>
        </section>

        <!-- ANCHOR: 다이얼로그-입력확인 -->
        <template>
            <v-dialog
                v-model="isIssuingCheckDialogVisible"
                width="500"
            >
                <v-card class="pa-0 rounded-lg">
                    <div class="le-heading6 pa-5">
                        Confirm Your Information
                    </div>

                    
                    <div
                        v-if="isIssuingSuccessLoading"
                        class="center-absolute"
                    >
                        <v-progress-circular
                            indeterminate
                            color="orange1"
                            size="60"
                            width="10"
                        ></v-progress-circular>
                    </div>

                    <div
                        class="le-text-body2 pl-5 pr-6"
                        style="min-height: 88px;"
                    >
                        <p class="mb-3">
                            The information you entered is as follows:
                        </p>

                        <strong>{{ name }}</strong><br>
                        <strong>{{ email }}</strong><br>
                        
                        <p class="mt-3">
                            Would you like to issue the badge with this information?
                        </p>
                    </div>

                    <div class="pa-5 d-flex justify-end gap-3">
                        <v-btn
                            v-ripple="{ class: 'text-blue3' }"
                            color="blue1"
                            outlined
                            :small="$vuetify.breakpoint.smAndDown"
                            depressed
                            class="text-white1"
                            @click="handleIssuingCheckDialogClose"
                        >
                            No
                        </v-btn>

                        <v-btn
                            color="orange1"
                            :small="$vuetify.breakpoint.smAndDown"
                            depressed
                            class="text-white1"
                            :class="{'disabled': isIssuingSuccessLoading }"
                            @click="handleSubmit"
                        >
                            Yes
                        </v-btn>
                    </div>
                </v-card>
            </v-dialog>
        </template>

        <!-- ANCHOR: 다이얼로그-발행완료 -->
        <template>
            <v-dialog
                v-model="isIssuingSuccessDialogVisible"
                width="500"
            >
                <v-card class="pa-0 rounded-lg">
                    <div class="le-heading6 pa-5">
                        Badge Issued
                    </div>

                    <div
                        class="le-text-body2 pl-5 pr-6"
                        style="min-height: 88px;"
                    >
                        The badge has been successfully issued.<br>
                        A notification has been sent to the email address you provided.<br>
                        <span class="text-red1">Please refer to the instructions on the page for more details.</span>
                    </div>

                    <div class="pa-5 d-flex justify-end gap-3">
                        <v-btn
                            color="orange1"
                            :small="$vuetify.breakpoint.smAndDown"
                            depressed
                            class="text-white1"
                            @click="handleIssuingSuccessDialogClose"
                        >
                            Confirm
                        </v-btn>
                    </div>
                </v-card>
            </v-dialog>
        </template>
    </div>
    <!-- !SECTION: Template -->
</template>

<script>
import { mapActions } from 'vuex';
import { getSampleBadgesMetaInfo } from '@/utils/metaInfo.js';
// import PageTitle from '@/components/PageTitle.vue';

export default {
    name: 'SampleBadgesPage',
    components: {
        // PageTitle
    },

    metaInfo() {
        return getSampleBadgesMetaInfo(this);
    },

    // SECTION: Data Properties
    data: function () {
        return {
            isIssuingSuccessLoading: false,
            isIssuingCheckDialogVisible: false,
            isIssuingSuccessDialogVisible: false,
            lang: 'ko-KR',
            name: '',
            email: '',
        };
    },
    // !SECTION: Data Properties

    // SECTION: Lifecycle Hooks
    created() {
        //
    },

    mounted() {
        //
    },

    beforeDestroy() {
        //
    },
    // !SECTION: Lifecycle Hooks

    // SECTION: Methods
    methods: {
        ...mapActions(
            'lecoslte2025', [ 'issueBadge' ]
        ),

        /* ============================================================
         * ANCHOR: 발행하기 버튼 클릭
         * ============================================================ */
        showIssuingCheckDialogVisible() { 
            // 유효성 검사
            if (!this.$refs.form.validate()) {
                console.log('validate!!');
                return;
            }
            this.isIssuingCheckDialogVisible = true;
        },

        handleIssuingCheckDialogClose() {
            this.isIssuingCheckDialogVisible = false;
        },

        /* ============================================================
         * ANCHOR: 네(발행하기) 버튼 클릭
         * ============================================================ */
        async handleSubmit() {
            // this.handleIssuingCheckDialogClose();
            // this.isIssuingSuccessDialogVisible = true;

            this.isIssuingSuccessLoading = true;

            try {
                // 유효성 검사
                // if (!this.$refs.form.validate()) {
                //     console.log('validate!!');
                //     return;
                // }

                const { lang, name, email } = this;

                this.issueBadge({ name, email, lang })
                    .then(res => {
                        console.log('res', res);

                        if (res.status === 200) {
                            this.isIssuingSuccessLoading = false;
                            // this.$router.push({ name: 'ContactUsFinishPage' });
                            this.handleIssuingCheckDialogClose();
                            this.isIssuingSuccessDialogVisible = true;
                            this.$nextTick(() => {
                                this.name = undefined;
                                this.email = undefined;
                            });
                        } else {
                            // 실패 처리
                            alert(`오류 발생: ${res.data}. 다시 시도해 주세요.`);
                            this.isIssuingSuccessLoading = false;
                        }
                    }).catch((error) => {
                        this.isIssuingSuccessLoading = false;

                        if (error.response) {
                            // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.
                            console.log(error.response.data);
                            console.log(error.response.status);
                            console.log(error.response.headers);

                            alert('오류 발생. 다시 시도해 주세요.');
                                    
                            // this.errMsg = error.response.request;
                            // this.activeModalErr = true;
                            // console.log('errMsg', this.errMsg);
                        }
                        else if (error.request) {
                            // 요청이 이루어 졌으나 응답을 받지 못했습니다.
                            // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
                            // Node.js의 http.ClientRequest 인스턴스입니다.
                            console.log(error.request);

                            alert('오류 발생. 다시 시도해 주세요.');

                            // this.errMsg = error.request;
                            // this.activeModalErr = true;
                        }
                        else {
                            // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
                            console.log('Error', error.message);

                            this.errMsg = error.message;
                            this.activeModalErr = true;
                        }
                        console.log(error.config);
                    }).finally(() => { 
                        console.log('end');
                        // this.$refs['btnIssuing'].disabled = false;
                    });

                // API 호출
                // const response = await this.issueBadge({
                //     lang: this.lang,
                //     name: this.name,
                //     email: this.email
                // });               

                // console.log('response.data.result', response.data);

                // if (response.data.result === 'Requested') { 
                //     this.handleIssuingCheckDialogClose();
                //     this.isIssuingSuccessDialogVisible = true;
                //     console.log('완료!');
                // }
            } catch (error) {
                this.handleError(error);
            } finally {
                console.log('Request completed');
                // 필요에 따라 버튼 비활성화 복원 등
                // this.$refs['btnInquery'].disabled = false;
            }
        },
        handleError(error) {
            // 에러 핸들링 함수
            if (error.response) {
                // 요청이 이루어졌으나 에러 응답을 받은 경우
                console.error('Error Response Data:', error.response.data);
                console.error('Error Response Status:', error.response.status);
                console.error('Error Response Headers:', error.response.headers);
                alert('서버 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.');
                this.isIssuingSuccessLoading = false;
            } else if (error.request) {
                // 요청이 이루어졌으나 응답이 없는 경우
                console.error('Error Request:', error.request);
                alert('서버와의 연결에 실패했습니다. 인터넷 연결을 확인해 주세요.');
                this.isIssuingSuccessLoading = false;
            } else {
                // 요청 설정 중 오류가 발생한 경우
                console.error('Error Message:', error.message);
                alert('오류가 발생했습니다. 다시 시도해 주세요. 지속적인 오류 발생 시 관리자에게 문의해 주세요.');
                this.isIssuingSuccessLoading = false;
            }
            console.error('Error Config:', error.config);
        },
        /* ============================================================
         * ANCHOR: 확인 버튼 클릭 (발행 완료)
         * ============================================================ */
        handleIssuingSuccessDialogClose() {
            this.isIssuingSuccessDialogVisible = false;
            this.resetForm();
        },
        resetForm() {
            this.name = '';
            this.email = '';
            this.$refs.form.resetValidation();
        },
    },
    // !SECTION: Methods
};
</script>
